module.exports = __webpack_public_path__ + "static/img/ninja-can-10.fea2dc2b.png";